<template>
    <div class="cmd-box">
        <el-row>
            <el-col span="12">
                <el-form ref="form" :model="form"  :inline="true"  label-width="80px" label-position="top">
                    <div>
                        <el-form-item label="设备SN">
                            <el-input v-model="form.sn" size="mini" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="机柜号">
                            <el-input v-model="form.equNo"  size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="最大温度">
                            <el-input v-model="form.maxTemp"  size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="最小温度">
                            <el-input v-model="form.minTemp"  size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="最大湿度">
                            <el-input v-model="form.maxHum"  size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="最小湿度">
                            <el-input v-model="form.minHum"  size="mini"></el-input>
                        </el-form-item>
                    </div>

                    <div>
                        <el-form-item label="定时温度" style="width: 100%">
                            <el-table
                                    :data="form.timeSetting"
                                    border
                                    style="width: 100%">
                                <el-table-column
                                        prop="start"
                                        label="开始时间"
                                >
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.start"  size="mini" placeholder="开始时间"></el-input>

                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="end"
                                        label="结束时间"
                                >
                                    <template slot-scope="scope">

                                        <el-input v-model="scope.row.end"  size="mini" placeholder="结束时间"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="maxTemp"
                                        label="最大温度"
                                >
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.maxTemp"  size="mini" placeholder="最大温度"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="minTemp"
                                        label="最小温度"
                                >
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.minTemp"  size="mini" placeholder="最小温度"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="maxHum"
                                        label="最大湿度"
                                >
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.maxHum"  size="mini" placeholder="最小湿度"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="minHum"
                                        label="最小湿度"
                                >
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.minHum"  size="mini" placeholder="最大温度"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="操作"
                                >
                                    <template slot-scope="scope">
                                        <el-button size="mini" @click="form.timeSetting.splice(form.timeSetting.indexOf(scope.row),1)">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div>
                                <el-button size="mini" @click="handleAddItems">新增</el-button>
                            </div>
                        </el-form-item>

                    </div>

                    <el-form-item>
                        <el-button type="primary" size="mini" @click="handleSubmit('form')">确定</el-button>
                        <el-button size="mini" @click="handleReset('form')">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col span="12">
                <div style="padding: 24px">
                    <div v-for="(log,i) in logs" :key="i" style="font-size: 12px;margin-bottom: 12px;word-break: break-word">
                        {{log}}
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "ConfigTempCmdBox",
        props: {
            sn: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                form: {
                    sn: '',
                    equNo:'1',
                    maxTemp:'20',
                    minTemp:'1',
                    maxHum:'0',
                    minHum:'0'
                },
                logs: [],
                afterTime: '',
                timer: ''
            }
        },
        watch: {
            sn: {
                immediate: true,
                handler() {
                    this.form.sn = this.sn;
                }
            }
        },
        methods: {
            handleAddItems() {
                this.form.timeSetting.push({
                    maxTemp:'',
                    minTemp:'',
                    maxHum:'',
                    minHum:'',
                    start:'',
                    end:''
                });
            },
            async handleSubmit() {
                this.logs = [];
                clearTimeout(this.timer);
                this.logs.push("正在准备发送指令...");
                await this.loadLog();
                this.timerLoadLog(1000);
                let resp = await this.$http.post(this.$api.$base.root + '/gw/server/configTemp', Object.assign({reqId: "AT" + new Date().getTime()}, this.form), {headers: {sn: this.sn}});
                if (resp.data.status === 200) {
                    this.logs.push("指令发送完成...");
                } else {
                    this.logs.push("指令发送失败，" + resp.data.desc);
                }
            },
            async loadLog() {
                let resp = await this.$http.post(this.$api.spDevLog.list, this.$qs.stringify({
                    sn: this.sn,
                    asc: true,
                    afterTimeStp: this.afterTime
                }));
                if (!this.afterTime) {
                    this.afterTime = resp.data.time;
                } else {
                    if (resp.data.data.spDevLogs && resp.data.data.spDevLogs.length) {
                        let spDevLogs = resp.data.data.spDevLogs;
                        this.afterTime = spDevLogs[spDevLogs.length - 1].createTime;
                        spDevLogs.forEach((e) => {
                            this.logs.push(e.content);
                        })
                    }
                }
                return;
            },
            async timerLoadLog(time) {
                if (!time) {
                    time = 1000;
                }
                return new Promise(async (res) => {
                    await this.loadLog();
                    this.timer = setTimeout(async () => {
                        res();
                        await this.timerLoadLog(time);
                    }, time);
                })
            },
            handleReset() {
                this.form = {
                    sn: this.sn,
                    equNo:'1',
                    maxTemp:'20',
                    minTemp:'1',
                    maxHum:'0',
                    minHum:'0',
                    timeSetting: []
                };
            }
        }
    }
</script>

<style scoped>
    .cmd-box {
    }
</style>